import React, { useState } from "react";
import { DollarSign, Filter } from "lucide-react";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

export default function MobileCard2() {
  const [isLogin, setIsLogin] = useState(true);

 const Icon=({icon,size}) =>(<>  {icon===0?<BookDown size={size}  color="#90CAF9" />:icon===1?<NotepadText size={size}  color="#90CAF9" 
        />:icon===2?<BookA size={size}  color="#90CAF9"  
        />:icon===3?<GalleryHorizontal size={size}   color="#90CAF9"  
        />:icon===4?<MonitorPlay size={size} color="#90CAF9" 
        />:icon===5?<Blocks size={size}  color="#90CAF9" />
       
       :icon===6?<DollarSign size={size}  color="#90CAF9" />:icon===7?<CalendarCog size={size}  color="#90CAF9" />:icon===8?<Aperture size={size}   color="#90CAF9" />:""}
     </>);
  return (<> 
    <div className="auth-card">
<div className="courses-carouselMob2">
        {[{course:1,title:"MoMoKo Classes , Mumbai ",lesson:"Learn, Earn And Return! "}].map((i,index) => (
         <><div className="carouselMob2-card" key={i?.course}>
           <div style={{padding:"5px"}}> </div>
            <div className="carouselMob2-card-text">
              <h1> {i?.title}</h1>
              <span>{i?.lesson}</span>
            </div>
          </div></> 
        ))}
      </div>
      <h2 className="auth-title">{isLogin ? "Welcome Back" : "Create Account"}</h2>
      <p className="auth-subtitle">
        {isLogin ? "Login to continue" : "Signup to get started"}
      </p>

      <div className="auth-inputs">
        {!isLogin && (
          <input type="text" placeholder="Full Name" className="auth-input" />
        )}

        <input type="email" placeholder="Email" className="auth-input" />

        <input type="password" placeholder="Password" className="auth-input" />
      </div>

      <button className="auth-btn">
        {isLogin ? "Login" : "Signup"}
      </button>

      <p className="auth-switch">
        {isLogin ? "Don't have an account?" : "Already have an account?"}
        <span onClick={() => setIsLogin(!isLogin)}>
          {isLogin ? " Signup" : " Login"}
        </span>
      </p>
    </div>
    <style>{`
    
    
    
/* Horizontal Carousel */
.courses-carouselMob2 {
  display: flex;justify-content:center;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 6px;
}

.courses-carouselMob2::-webkit-scrollbar {
  display: none;
}

.carouselMob2-card {
  min-width: 140px;
  background: #101218;
  border-radius: 14px;
  border: 1px solid #1a1f2b;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
}

.carouselMob2-card img {
  width: 100%;
  height: 90px;
  object-fit: cover;
}

.carouselMob2-card-text {
  padding: 10px;
}

.carouselMob2-card-text h1 {
   color: #48556fff !important;
  margin: 0 0 4px;
}

.carouselMob2-card-text span {
  color: #abbcddff !important;
  font-size: 12px;
}
    .auth-card {
  width: 100%;
  max-width: 300px;
  background: #101218;
  border: 1px solid #1a1f2b;
  border-radius: 16px;
  padding: 24px 20px;
  margin: 30px auto;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0,0,0,0.35);
}

.auth-title {
  margin: 0;
  font-size: 20px;
  color: #e9eef6;
  font-weight: 600;
}

.auth-subtitle {
  margin: 4px 0 20px;
  font-size: 13px;
  color: #a6b0c2;
}

.auth-inputs {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.auth-input {
  width: 90%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #1a1f2b;
  background: #0b0c10;
  color: #e9eef6;
  font-size: 14px;
  outline: none;
}

.auth-input::placeholder {
  color: #77809a;
}

.auth-btn {
  width: 100%;
  margin-top: 18px;
  padding: 12px;
  border-radius: 10px;
  background: #6aa2ff;
  color: #000;
  border: none;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.auth-btn:active {
  transform: scale(0.98);
}

.auth-switch {
  margin-top: 12px;
  font-size: 13px;
  color: #a6b0c2;
}

.auth-switch span {
  color: #6aa2ff;
  cursor: pointer;
  margin-left: 4px;
}
`}</style></>
  );
}
